import classNames from 'classnames/bind';
import { makePercentFromRate } from '@flight-workspace/common-client/src/util/number';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  savingRate: number;
  isMemberFare?: boolean;
}

export default function Travelclub({ savingRate }: IProps) {
  if (savingRate === 0) return null;

  return (
    <div className={cx('Travelclub')}>
      <div className={cx('desc')}>
        <i className={cx('service')} title="트래블클럽" />
        <span className={cx('txt')}>
          {makePercentFromRate(savingRate)}%{' '}
          <a
            className={cx('info')}
            href="https://travel-event.naver.com/promotion/travelclub?anchor=howto"
            target="_blank"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            추가적립
          </a>
        </span>
      </div>
    </div>
  );
}
